<template>
  <div>
    <div class="card card-custom gutter-b">
      <div class="card-body">
        <form @submit.prevent="fetchReport">
          <div class="form-row align-items-end">
            <div class="form-group col-md-3">
              <date-picker type="date" v-model="filters.from" format="YYYY-MM-DD HH:mm:ss"
                display-format="HH:mm jYYYY/jMM/jDD" color="#4554a0" class="date-picker-style" label="از تاریخ" />
            </div>

            <div class="form-group col-md-3">
              <date-picker type="date" v-model="filters.to" format="YYYY-MM-DD HH:mm:ss"
                display-format="HH:mm jYYYY/jMM/jDD" color="#4554a0" class="date-picker-style" label="تا تاریخ" />
            </div>

            <div class="form-group col-md-3">
              <label>شرکت</label>
              <select v-model="filters.company" class="form-control">
                <option value="">انتخاب کنید</option>
                <option v-for="company in companies" :key="company.id" :value="company.id">
                  {{ company.title }} ({{ company.name }})
                </option>
              </select>
            </div>

            <div class="form-group col-md-3">
              <button class="btn btn-primary btn-block" :disabled="loading">
                <i v-if="!loading" class="flaticon2-search-1"></i>
                <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                دریافت گزارش
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div v-if="loaded && adminReportsLives.length" class="card card-custom gutter-b">
      <div class="card-body">
        <div v-if="downloadUrl" class="mb-4 text-rigth">
          <a :href="downloadUrl" target="_blank" class="btn btn-primary ">
            <i class="flaticon-download"></i>
            دانلود فایل اکسل
          </a>
        </div>
        <div class="table-responsive">
          <table class="table table-head-custom table-head-bg table-borderless table-vertical-center">
            <thead>
              <tr>
                <th>شماره موبایل</th>
                <th>طول (Length)</th>
                <th>تعداد (Count)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r, i) in adminReportsLives" :key="i">
                <td>{{ r.cellphone }}</td>
                <td>{{ r.length }}</td>
                <td>{{ r.count }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-if="loaded && adminReportsLives.length === 0" class="alert alert-primary">
      گزارشی یافت نشد.
    </div>
  </div>
</template>

<script>
import {
  FETCH_ADMIN_REPORTS_LIVES,
} from "@/core/services/store/admin/admin-reports.module";

import {
  FETCH_COMPANIES,
} from "@/core/services/store/admin/companies.module";

import { mapGetters, mapActions } from "vuex";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "admin-lives-reports",
  data() {
    return {
      filters: {
        from: "",
        to: "",
        company: "",
      },
      loaded: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      adminReportsLives: "adminReportsLives",
      downloadUrl: "adminLivesDownloadUrl",
      companies: "companies",
    }),
  },
  methods: {
    ...mapActions({
      fetchAdminReportsLives: FETCH_ADMIN_REPORTS_LIVES,
      fetchCompanies: FETCH_COMPANIES,
    }),

    async fetchReport() {
      this.loading = true;
      this.loaded = false;
      try {
        await this.fetchAdminReportsLives(this.filters);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      } finally {
        this.loaded = true;
        this.loading = false;
      }
    },
  },
  async mounted() {
    try {
      await this.fetchCompanies();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("Error fetching companies:", e);
    }
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
};
</script>
